/**
 * Wordle module enum-ish constants — the persisted vocabulary and the game's
 * fixed dimensions.
 *
 * The app-wide invariant holds here: **persisted enum values are English
 * snake_case**; only what a person reads is Dutch, and that lives in the client.
 * So a tile is `exact`/`present`/`absent` and a game is `in_progress`/`won`/
 * `lost` — never the UPPERCASE conceptual names used when describing the rules.
 */
/** The module's sync table set — disjoint from every other module's. */
export const WORDLE_SYNC_TABLES = ['wordle_games'];
export function isWordleSyncTable(value) {
    return WORDLE_SYNC_TABLES.includes(value);
}
/** Per-tile feedback. Green / yellow / grey, in the app's stored spelling. */
export const TILE_STATES = ['exact', 'present', 'absent'];
/** A game is in progress until it is solved or the attempts run out. */
export const GAME_STATUSES = ['in_progress', 'won', 'lost'];
/** The shared daily puzzle, or an ephemeral practice round. */
export const GAME_MODES = ['daily', 'random'];
/** The board's fixed dimensions (spec §5 defaults). */
export const WORD_LENGTH = 5;
export const MAX_ATTEMPTS = 6;
/**
 * The household's timezone. The daily puzzle turns over at local midnight, so
 * both phones compute the same word for "today" and a reminder lands in the
 * evening the household actually keeps. A single-household app, so a constant.
 */
export const PUZZLE_TZ = 'Europe/Amsterdam';
//# sourceMappingURL=enums.js.map